import { render } from "./EformsView.vue?vue&type=template&id=b7b90404&ts=true"
import script from "./EformsView.vue?vue&type=script&lang=ts"
export * from "./EformsView.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/project/shmu/shmu/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__